(function () {
  var root = document.querySelector("[data-zc-favourite-routes]");
  if (!root || root.dataset.zcFrInit === "true") return;
  root.dataset.zcFrInit = "true";

  var mapEl = root.querySelector("[data-zc-fr-map]");
  var shopLogo = root.getAttribute("data-shop-logo") || "";
  var reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var TARGET_POINTS = 96;
  var PALETTE = ["#2b5da8", "#c48a00", "#0d7a68", "#c45c12", "#9b4d96"];
  var state = {
    map: null,
    lines: {},
    starts: {},
    colors: {},
    data: null,
    activeId: null,
  };

  function colorFor(id) {
    return state.colors[String(id)] || PALETTE[0];
  }

  function paintRoute(id, color) {
    var key = String(id);
    state.colors[key] = color;
    root.querySelectorAll('[data-zc-fr-pick="' + key + '"], [data-zc-fr-row="' + key + '"], [data-zc-fr-now]').forEach(function (el) {
      el.style.setProperty("--fr-route", color);
    });
  }

  function colorFromDom(id) {
    var key = String(id);
    var el =
      root.querySelector('[data-zc-fr-pick="' + key + '"][data-zc-fr-color]') ||
      root.querySelector('[data-zc-fr-row="' + key + '"][data-zc-fr-color]');
    if (!el) return null;
    var c = el.getAttribute("data-zc-fr-color");
    return c && c.trim() ? c.trim() : null;
  }

  function assignRouteColors() {
    var order = [];
    root.querySelectorAll("[data-zc-fr-pick]").forEach(function (btn) {
      var id = btn.getAttribute("data-zc-fr-pick");
      if (!id) return;
      id = String(id);
      if (order.indexOf(id) === -1) order.push(id);
    });
    if (!order.length) {
      root.querySelectorAll("[data-zc-fr-row]").forEach(function (row) {
        var id = row.getAttribute("data-zc-fr-row");
        if (!id) return;
        id = String(id);
        if (order.indexOf(id) === -1) order.push(id);
      });
    }
    order.forEach(function (id, index) {
      paintRoute(id, colorFromDom(id) || PALETTE[index % PALETTE.length]);
    });
  }

  function loadLeaflet(cb) {
    if (window.L) {
      cb();
      return;
    }
    var script = document.createElement("script");
    script.src = "https://unpkg.com/leaflet@1.9.4/dist/leaflet.js";
    script.crossOrigin = "";
    script.onload = cb;
    document.head.appendChild(script);
  }

  function readManifest() {
    var el = document.getElementById("zc-fr-manifest");
    if (!el) return [];
    try {
      var parsed = JSON.parse(el.textContent);
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      return [];
    }
  }

  function downsample(points) {
    if (!points || !points.length) return [];
    var step = Math.max(1, Math.floor(points.length / TARGET_POINTS));
    var sampled = points.filter(function (_, i) {
      return i % step === 0;
    });
    var last = points[points.length - 1];
    if (sampled[sampled.length - 1] !== last) sampled.push(last);
    return sampled;
  }

  function rwgpsToRoute(id, payload) {
    var route = payload.route || payload;
    var sampled = downsample(route.track_points || []);
    var line = sampled
      .filter(function (p) {
        return p && p.x != null && p.y != null;
      })
      .map(function (p) {
        return [Number(p.y.toFixed(5)), Number(p.x.toFixed(5))];
      });
    var elev = sampled.map(function (p) {
      return Number((p.e || 0).toFixed(1));
    });
    return {
      id: String(id),
      name: String(route.name || "").trim(),
      km: Number(((route.distance || 0) / 1000).toFixed(1)),
      gain: Math.round(route.elevation_gain || 0),
      unpaved: Math.round(route.unpaved_pct || 0),
      line: line,
      elev: elev,
      start: line[0] || null,
    };
  }

  function fetchRwGps(id) {
    return fetch("https://ridewithgps.com/routes/" + encodeURIComponent(id) + ".json", {
      credentials: "omit",
    }).then(function (res) {
      if (!res.ok) throw new Error("route " + id + " " + res.status);
      return res.json();
    }).then(function (data) {
      return rwgpsToRoute(id, data);
    });
  }

  function shopFromRoot() {
    return {
      lat: parseFloat(root.getAttribute("data-shop-lat")) || 43.4563,
      lng: parseFloat(root.getAttribute("data-shop-lng")) || -80.4944,
      name: root.getAttribute("data-shop-name") || "Ziggy's Cycle",
    };
  }

  function loadRouteData() {
    var manifest = readManifest();
    var shop = shopFromRoot();
    if (!manifest.length) return Promise.resolve({ shop: shop, routes: [] });

    root.setAttribute("aria-busy", "true");
    root.classList.add("is-loading");

    return Promise.all(
      manifest.map(function (entry) {
        return fetchRwGps(entry.id).catch(function () {
          return null;
        });
      })
    ).then(function (routes) {
      root.classList.remove("is-loading");
      root.removeAttribute("aria-busy");
      return {
        shop: shop,
        routes: routes.filter(Boolean),
      };
    });
  }

  function fmtDistance(km) {
    return km + " km";
  }

  function fmtElev(gain) {
    return gain + " m";
  }

  function fmtSurface(pct) {
    return pct + "% unpaved";
  }

  function hydrateRowStats(route) {
    var row = root.querySelector('[data-zc-fr-row="' + route.id + '"]');
    if (!row) return;

    var stats = row.querySelector(".zc-fr__stats");
    if (!stats && (route.km || route.gain || route.unpaved)) {
      stats = document.createElement("ul");
      stats.className = "zc-fr__stats";
      var anchor = row.querySelector(".zc-fr__note-copy") || row.querySelector(".zc-fr__name");
      if (anchor && anchor.parentNode) anchor.parentNode.insertBefore(stats, anchor.nextSibling);
    }
    if (stats) {
      var items = stats.querySelectorAll("li");
      if (!items.length) {
        var html = "";
        if (route.km) html += "<li>" + fmtDistance(route.km) + "</li>";
        if (route.gain) html += "<li>" + fmtElev(route.gain) + "</li>";
        if (route.unpaved != null && route.unpaved !== "") html += "<li>" + fmtSurface(route.unpaved) + "</li>";
        if (html) stats.innerHTML = html;
      }
    }

    var pick = root.querySelector('[data-zc-fr-pick="' + route.id + '"]');
    if (pick) {
      var meta = pick.querySelector(".zc-fr__pick-meta");
      if (route.km && (!meta || !meta.textContent.trim())) {
        if (!meta) {
          meta = document.createElement("span");
          meta.className = "zc-fr__pick-meta";
          pick.appendChild(meta);
        }
        meta.textContent = fmtDistance(route.km);
      }
    }
  }

  function lineStyle(active, color, overview) {
    if (active) {
      return { color: color, weight: 6, opacity: 1 };
    }
    if (overview) {
      return { color: color, weight: 3, opacity: 0.48 };
    }
    return { color: color, weight: 2.75, opacity: 0.32 };
  }

  function syncStartMarkers() {
    Object.keys(state.starts).forEach(function (key) {
      var marker = state.starts[key];
      if (!marker || !marker.getElement) return;
      var el = marker.getElement();
      if (!el) return;
      if (!state.activeId) {
        el.style.opacity = "0.65";
        return;
      }
      el.style.opacity = key === state.activeId ? "1" : "0.38";
    });
  }

  function routeById(id) {
    if (!state.data || !state.data.routes) return null;
    for (var i = 0; i < state.data.routes.length; i++) {
      if (String(state.data.routes[i].id) === String(id)) return state.data.routes[i];
    }
    return null;
  }

  function drawElevInto(host, id, height) {
    var route = routeById(id);
    if (!host || !route || !route.elev || route.elev.length < 2) return;
    var h = height || 64;
    var elev = route.elev;
    var min = Math.min.apply(null, elev);
    var max = Math.max.apply(null, elev);
    var span = Math.max(max - min, 8);
    var w = 320;
    var pad = 4;
    var pts = elev
      .map(function (e, i) {
        var x = pad + (i / (elev.length - 1)) * (w - pad * 2);
        var y = h - pad - ((e - min) / span) * (h - pad * 2);
        return x.toFixed(1) + "," + y.toFixed(1);
      })
      .join(" ");
    var floor = " " + (w - pad).toFixed(1) + "," + (h - pad) + " " + pad + "," + (h - pad);
    var color = colorFor(id);
    var gid = "zc-fr-elev-" + String(id) + "-" + (height || 64);
    host.innerHTML =
      '<svg viewBox="0 0 ' +
      w +
      " " +
      h +
      '" role="img" aria-label="Elevation profile">' +
      "<defs><linearGradient id=\"" +
      gid +
      '" x1="0" y1="0" x2="0" y2="1">' +
      '<stop offset="0%" stop-color="' +
      color +
      '" stop-opacity="0.38"></stop>' +
      '<stop offset="100%" stop-color="' +
      color +
      '" stop-opacity="0.04"></stop>' +
      "</linearGradient></defs>" +
      '<polygon class="zc-fr__elev-fill" fill="url(#' +
      gid +
      ')" points="' +
      pts +
      floor +
      '"></polygon>' +
      '<polyline class="zc-fr__elev-line" points="' +
      pts +
      '"></polyline></svg>';
  }

  function drawElev(id) {
    drawElevInto(root.querySelector('[data-zc-fr-elev="' + id + '"]'), id, 64);
  }

  function setText(el, value) {
    if (!el) return;
    el.textContent = value || "";
  }

  function syncMapDock(id) {
    var dock = root.querySelector("[data-zc-fr-map-dock]");
    if (!dock) return;

    if (!id) {
      dock.hidden = true;
      return;
    }

    var row = root.querySelector('[data-zc-fr-row="' + id + '"]');
    if (!row) {
      dock.hidden = true;
      return;
    }

    dock.hidden = false;
    dock.style.setProperty("--fr-route", colorFor(id));

    var name = (row.querySelector(".zc-fr__name") || {}).textContent || "";
    setText(dock.querySelector("[data-zc-fr-dock-name]"), name);

    var statsHost = dock.querySelector("[data-zc-fr-dock-stats]");
    var stats = row.querySelector(".zc-fr__stats");
    if (statsHost) statsHost.innerHTML = stats ? stats.innerHTML : "";

    var elevHost = dock.querySelector("[data-zc-fr-dock-elev]");
    if (elevHost) {
      elevHost.innerHTML = "";
      drawElevInto(elevHost, id, 36);
    }

    var cta = dock.querySelector("[data-zc-fr-dock-cta]");
    var source = row.querySelector(".zc-fr__btn");
    var template = root.querySelector("[data-zc-fr-now]");
    var ctaLabel = (template && template.getAttribute("data-cta-label")) || "Ride with GPS";
    if (cta) {
      if (source && source.getAttribute("href")) {
        cta.href = source.getAttribute("href");
        cta.textContent = ctaLabel.replace(/^Open in\s+/i, "") || "Ride with GPS";
        cta.hidden = false;
      } else {
        cta.removeAttribute("href");
        cta.hidden = true;
      }
    }
  }

  function setActive(id, fly) {
    state.activeId = id ? String(id) : null;
    var overview = !state.activeId;

    Object.keys(state.lines).forEach(function (key) {
      var on = key === state.activeId;
      state.lines[key].setStyle(lineStyle(on, colorFor(key), overview));
      if (on) state.lines[key].bringToFront();
    });
    syncStartMarkers();

    root.querySelectorAll("[data-zc-fr-pick]").forEach(function (btn) {
      var on = btn.getAttribute("data-zc-fr-pick") === state.activeId;
      btn.classList.toggle("is-active", on);
      btn.setAttribute("aria-pressed", on ? "true" : "false");
    });

    root.querySelectorAll("[data-zc-fr-row]").forEach(function (row) {
      row.classList.toggle("is-active", row.getAttribute("data-zc-fr-row") === state.activeId);
    });

    syncMapDock(state.activeId);

    var route = routeById(state.activeId);
    if (fly && route && route.line && route.line.length && state.map) {
      var bounds = window.L.latLngBounds(route.line);
      var fitOpts = {
        maxZoom: 13,
        paddingTopLeft: [40, 40],
        paddingBottomRight: [64, 40],
      };
      if (reduceMotion) state.map.fitBounds(bounds, fitOpts);
      else state.map.flyToBounds(bounds, Object.assign({ duration: 0.85 }, fitOpts));
    }
  }

  function fitAll() {
    if (!state.map) return;
    var bounds = window.L.latLngBounds([]);
    Object.keys(state.lines).forEach(function (key) {
      bounds.extend(state.lines[key].getBounds());
    });
    if (!bounds.isValid()) return;
    setActive(null, false);
    if (reduceMotion) state.map.fitBounds(bounds, { padding: [28, 28] });
    else state.map.flyToBounds(bounds, { padding: [28, 28], duration: 0.85 });
  }

  function initMap(data) {
    if (!mapEl || !window.L || !data) return;
    state.data = data;
    var shopLat = (data.shop && data.shop.lat) || 43.4563;
    var shopLng = (data.shop && data.shop.lng) || -80.4944;
    state.map = window.L.map(mapEl, {
      scrollWheelZoom: false,
      attributionControl: true,
    });
    state.map.setView([shopLat, shopLng], 11);
    mapEl._zcMap = state.map;

    window.L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
      maxZoom: 18,
      attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
    }).addTo(state.map);

    var firstLocal = root.querySelector('[data-zc-fr-pick][data-region="local"]');
    var defaultId = firstLocal ? firstLocal.getAttribute("data-zc-fr-pick") : null;

    assignRouteColors();

    (data.routes || []).forEach(function (route) {
      hydrateRowStats(route);
      var color = colorFor(route.id);
      if (!route.line || route.line.length < 2) return;
      var line = window.L.polyline(route.line, lineStyle(false, color)).addTo(state.map);
      line.on("click", function () {
        setActive(route.id, true);
      });
      state.lines[String(route.id)] = line;

      if (route.start) {
        var start = window.L.marker(route.start, {
          icon: window.L.divIcon({
            className: "zc-fr__start",
            html: '<span class="zc-fr__start-dot" style="--fr-route:' + color + '"></span>',
            iconSize: [10, 10],
            iconAnchor: [5, 5],
          }),
          keyboard: false,
        }).addTo(state.map);
        start.on("click", function () {
          setActive(route.id, true);
        });
        state.starts[String(route.id)] = start;
      }
      drawElev(route.id);
    });

    if (data.shop && data.shop.lat && data.shop.lng) {
      var shopInner = shopLogo
        ? '<img class="zc-rtb__shop-marker-logo" src="' +
          String(shopLogo).replace(/"/g, "&quot;") +
          '" alt="" width="56" height="32" decoding="async">'
        : '<svg class="zc-rtb__shop-marker-bike" viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
          '<circle cx="5.5" cy="16.5" r="3.5"/><circle cx="18.5" cy="16.5" r="3.5"/>' +
          '<path d="M12 16.5L9 9h4l3.5 7.5"/><path d="M9 9H6.5"/><path d="M15 5.5h3.5l1.5 4"/>' +
          "</svg>";
      window.L.marker([data.shop.lat, data.shop.lng], {
        icon: window.L.divIcon({
          className: "zc-rtb__shop-marker",
          html:
            '<span class="zc-rtb__shop-marker-pin" aria-hidden="true">' +
            '<span class="zc-rtb__shop-marker-face">' +
            shopInner +
            "</span>" +
            '<span class="zc-rtb__shop-marker-tip"></span>' +
            "</span>",
          iconSize: [36, 44],
          iconAnchor: [18, 44],
        }),
        title: data.shop.name || "Ziggy's Cycle",
        keyboard: false,
      }).addTo(state.map);
    }

    function frameMap() {
      state.map.invalidateSize();
      if (defaultId && routeById(defaultId)) setActive(defaultId, true);
      else if (Object.keys(state.lines).length) fitAll();
      else state.map.setView([shopLat, shopLng], 11);
    }

    if (state.map.whenReady) state.map.whenReady(frameMap);
    else setTimeout(frameMap, 80);

    if (mapEl) {
      mapEl.addEventListener(
        "wheel",
        function (e) {
          if (e.ctrlKey || e.metaKey) return;
          window.scrollBy({ top: e.deltaY, left: 0, behavior: "auto" });
        },
        { passive: true }
      );
    }
  }

  root.addEventListener("click", function (event) {
    var pick = event.target.closest("[data-zc-fr-pick]");
    if (pick) {
      setActive(pick.getAttribute("data-zc-fr-pick"), true);
      if (window.matchMedia("(max-width: 860px)").matches) {
        var scrollTarget = root.querySelector(".zc-fr__map-wrap") || mapEl;
        if (scrollTarget) {
          scrollTarget.scrollIntoView({ behavior: reduceMotion ? "auto" : "smooth", block: "start" });
        }
      }
      return;
    }
    if (event.target.closest("[data-zc-fr-all]")) fitAll();
  });

  Promise.all([
    new Promise(function (resolve) {
      loadLeaflet(resolve);
    }),
    loadRouteData(),
  ]).then(function (results) {
    initMap(results[1]);
  });
})();
